// Versioned localStorage wrappers for Play Tsoro
const PREFIX = "playtsoro:v1:";

export const KEYS = {
  settings: PREFIX + "settings",
  stats: PREFIX + "stats",
  savedGame: PREFIX + "savedGame",
  tutorialProgress: PREFIX + "tutorialProgress",
  theme: PREFIX + "theme",
  recentRulesets: PREFIX + "recentRulesets",
};

export function load(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch (e) {
    console.warn("Failed to load", key, e);
    return fallback;
  }
}

export function save(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    console.warn("Failed to save", key, e);
    return false;
  }
}

export function remove(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
}

export function clearAll() {
  Object.values(KEYS).forEach(remove);
}
